import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

export default () => async (dispatch, getState) => {
	const state = getState()
	const projectUrl = currentRouteParamsRecordId(state)
	return dispatch(apiRequest(GET_PROJECT, { projectUrl }))
}
